import React from 'react'
import { Col, Row } from 'antd'

export default function News ({ news }) {
  return (
    <Row style={{ background: 'linear-gradient(white, teal, white)', margin: '1em 0 5em 0' }}>
      <Col span={8}>
        {news}
      </Col>
      <Col span={16} >
        <img style={{}} src="/images/box-exterieur.png" title="Image de la Box Médicale extérieur" alt="Image de la Box Médicale extérieur" height={400} />
      </Col>
    </Row>
  )
}
